import Vue from 'vue';
import store from './../../store';
import orderPickupTransformer from './../../transformers/orderPickup';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const orderPickups = orderPickupTransformer.fetchCollection(data.data);

  let pagination = {};
  if (data.pagination) {
    pagination = paginationTransformer.fetch(data.pagination);
  }
  store.dispatch('fetchPaginatedOrderPickups', { orderPickups, pagination });
  resolve();
};

const failed = (error, reject) => reject(error);

export default (params = {}) => (
  new Promise((resolve, reject) => (
    Vue.$http.get(helpers.buildUrl('/orderPickups', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    })
  ))
);



// WEBPACK FOOTER //
// ./src/app/services/orderPickup/items.js